export default __webpack_public_path__ + "static/media/waiting-service.d521fea5.svg";